import StoreSettingImportPage from './StoreSettingImportPage';

export default StoreSettingImportPage;
